    <don-campaigns-list
      [campaigns]="campaigns"
      [selectedId]="selectedId"
      (select)="select.emit($event)"
      class="d-flex flex-column gap-2"
    >
    </don-campaigns-list>
